import { directus } from "../Config/ApiUrls";
import { Api } from "../Config/Requests";

export const requestcategories = async (data) => {
    return Api.GetRequest(directus + `items/categories?limit=25&fields[]=hasPromo&fields[]=name&fields[]=icons&fields[]=brands&fields[]=parent_category_id&fields[]=status&fields[]=id&sort[]=id&page=1&filter[_and][0][parent_category_id][_null]=true`);
};

export const requestsubcategories = async (data) => {
    return Api.GetRequest(directus + `items/categories?limit=25&fields[]=hasPromo&fields[]=name&fields[]=parent_category_id&fields[]=status&fields[]=icons&fields[]=id&sort[]=id&page=1&filter[_and][0][parent_category_id][_eq]=${data.id}`);
};

export const requestbrands = async (data) => {
    // Build the API request URL based on `data`
    const baseUrl = `${directus}items/categories_Values?fields[]=Values_id.name&fields[]=Values_id.id&fields[]=id`;
    const url = data ? `${baseUrl}&filter[_and][0][categories_id]=${data.id}` : baseUrl;

    // Fetch data
    const brands = await Api.GetRequest(url);
    // Use Map to deduplicate
    const distinctValuesMap = new Map();
    brands.data.data.forEach((item, index) => {

        const key = item.Values_id.id;
        if (!distinctValuesMap.has(key)) {

            distinctValuesMap.set(key, item.Values_id); // Add if not already present
        }
    });

    const distinctValues = Array.from(distinctValuesMap.values());

    return distinctValues;
};


export const requestproducts = async (data) => {
    let filter = '';
    data.data.forEach((item, index) => {
        filter += `&filter[_or][${index}][category_id][id][_eq]=${item.id}`;
    });
    const searchQuery = data.search ? `&search=${data.search}` : ''; // Conditionally add search
    const countdata = await Api.GetRequest(`https://api-dev.tabta.net/items/products?aggregate[countDistinct]=id${searchQuery}${filter}`);
    const products = await Api.GetRequest(
        `https://api-dev.tabta.net/items/products?limit=15&fields[]=cashback&fields[]=category_id&fields[]=name&fields[]=status&fields[]=product_image&fields[]=id&sort[]=id&page=${data.page}${searchQuery}${filter}`
    );
    const total = countdata.data.data[0].countDistinct.id
    const pages = Math.ceil(total / 25)
    return { ...products.data, total, pages }
};


// Define All User APIs
const CategoriesApiRequests = {
    requestcategories,
    requestsubcategories,
    requestbrands,
    requestproducts
};
export default CategoriesApiRequests;